module.exports = __webpack_public_path__ + "static/IMG_1188-d3495c46aed18c632923776b8ee14654.jpg";